module.exports = __webpack_public_path__ + "files/841ee81285947c5c6b8813d52fb9c2d2.png";